<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc">Contents</h1>
<p class="toc"><a class="hlink" href="#/OEBPS/dedi.htm">Dedication</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ack.htm">Acknowledgments</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/pro.htm">Prologue</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter1.htm">One</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter2.htm">Two</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter3.htm">Three</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter4.htm">Four</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter5.htm">Five</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter6.htm">Six</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter7.htm">Seven</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter8.htm">Eight</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter9.htm">Nine</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter10.htm">Ten</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter11.htm">Eleven</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter12.htm">Twelve</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter13.htm">Thirteen</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter14.htm">Fourteen</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter15.htm">Fifteen</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter16.htm">Sixteen</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter17.htm">Seventeen</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter18.htm">Eighteen</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter19.htm">Nineteen</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/chapter20.htm">Twenty</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/epi.htm">Epilogue</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?79718e5a